import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const logotypeParallax = () => {

	let logotype = document.querySelector('[data-el="header-logotype"]')

	if (!logotype) return

	if (window.innerWidth > 782) {
		gsap.fromTo(logotype, {
			y: 0,
		}, {
			y: '-100%',
			duration: 1,
			scrollTrigger: {
				trigger: document.body,
				start: 'top top',
				end: '+=200',
				scrub: 0.2,
				// markers: true,
			}
		})
	}
}

export default () => { }